export default "__VITE_ASSET__a583535c__"